import {Injectable} from '@angular/core';
import {DaoGeneric} from '@Services/base/daoService';
import {UrlModel} from './url.model';

import {environment} from '@Env/environment';
import {HttpClient} from '@angular/common/http';
import {FormModel} from '../../components/form/models';

@Injectable({ providedIn: 'root' })
export class UrlService extends DaoGeneric<UrlModel> {
  apiUrl = `${environment.baseUrl}/demat/url_form/`;
  constructor(private httpClient: HttpClient) {
    super(httpClient);
  }
  getRootUrl(): string {
    return this.apiUrl;
  }
  /**
   * Proposition du slug du formulaire
   * @param {string} formUUID
   * @param {string} name : nom source pour déterminer un slug
   * @constructor
   */
  public slugProposal(formUUID, name: string) {
    const params = {
      'form_uuid': formUUID,
      'name': name
    };
    const url = `${this.getRootUrl()}slug_proposal/`;
    return this.httpClient.get(url, { params });
  }

  /**
   * Mise à jour du slug
   * @param {FormModel} form
   */
  public slugUpdate(form: FormModel) {
    const url = `${this.getRootUrl()}slug_update/`;
    return this.httpClient.patch(url, { 'form_uuid': form.uuid });
  }

  /**
   * Test si le slug existe déjà
   */
  public slugExist(slug: string) {
    const params = {
      'slug': slug
    };
    const url = `${this.getRootUrl()}slug_exist/`;
    return this.httpClient.get(url, { params });
  }

  /**
   * Suppression de toutes les URLs pointant sur un formulaire
   */
  deleteUrlByForm(formId: number) {
      const url = `${this.getRootUrl()}${formId}/delete_slugs_by_form/`;
      return this.httpClient.delete(url);
  }
}
